<template>
  <div class="full_layout">
    <h3 class="informationTitle">朝圣之路 活动规则</h3>
    <div class="informationBox">
      <ul class="useragreement">
        <li>
          <div class="t1">参与活动的产品范围</div>
          <p>权益兑换卡只在意甲&amp;西甲俱乐部的产品中拆出（包含十元包，三十元包队盒，one&amp;two 等）</p>
          <p>产品大礼包在除great 10之外的所有产品中都有概率拆出。</p>
        </li>
        <li>
          <div class="t1">奖品详情说明</div>
          <div class="t3">
            <div class="t2">权益兑换卡A（尤文图斯足球俱乐部）</div>
            <p>机酒：国内指定城市至欧洲目的地往返机票和当地酒店住宿</p>
            <p>球赛门票：合作俱乐部：尤文图斯足球俱乐部比赛门票和俱乐部参观权益</p>
          </div>
          <div class="t3">
            <div class="t2">权益兑换卡B（巴塞罗那足球俱乐部）</div>
            <p>机酒：国内指定城市至欧洲目的地往返机票和当地酒店住宿</p>
            <p>球赛门票：合作俱乐部：巴塞罗那足球俱乐部比赛门票和俱乐部参观权益</p>
          </div>
          <div class="t3">
            <div class="t2">DAKA十周年礼包(3份): DAKA 发行的19款产品各1盒</div>
            <table class="productTable">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>产品名称</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>1</td><td>2024-25 阿贾克斯足球俱乐部官方球星卡</td></tr>
                <tr><td>2</td><td>2025 深圳新鹏城足球俱乐部官方球星卡</td></tr>
                <tr><td>3</td><td>2024-25 赛季纽卡斯尔联足球俱乐部官方球星卡</td></tr>
                <tr><td>4</td><td>2026 克罗地亚国家足球队系列官方球星卡</td></tr>
                <tr><td>5</td><td>2025-26 国际米兰足球俱乐部ONE&amp;TWO系列官方球星卡</td></tr>
                <tr><td>6</td><td>25-26巴塞罗那足球俱乐部ONE&amp;TWO系列官方球星卡</td></tr>
                <tr><td>7</td><td>25-26 AC米兰足球俱乐部ONE&amp;TWO系列官方球星卡</td></tr>
                <tr><td>8</td><td>25-26皇家马德里足球俱乐部Los Merengues系列官方球星卡</td></tr>
                <tr><td>9</td><td>25-26尤文图斯队盒</td></tr>
                <tr><td>10</td><td>2025-26 赛季国际米兰足球俱乐部 TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>11</td><td>2026 克罗地亚国家足球队TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>12</td><td>2026 荷兰国家足球队TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>13</td><td>2025-26 尤文图斯足球俱乐部 TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>14</td><td>25-26 AC米兰足球俱乐部 TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>15</td><td>25-26巴塞罗那篮球俱乐部 TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>16</td><td>2026科莫足球俱乐部 TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>17</td><td>26-27皇家马德里足球俱乐部 TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>18</td><td>26-27巴塞罗那足球俱乐部 TOP AUDIENCE系列官方球星卡</td></tr>
                <tr><td>19</td><td>中网系列官方球星卡</td></tr>
              </tbody>
            </table>
            <p>注：以上奖品均为单人单次使用，不可拆分、不可兑换现金、不可转让（获奖者本人使用），具体限制及违反后果详见"重要说明与免责条款"第3、4条。</p>
          </div>
        </li>
        <li>
          <div class="t1">兑换流程</div>
          <div class="t3">
            <div class="t2">Step 01：</div>
            <p>刮开兑换卡背面的涂层，获取唯一兑换码</p>
          </div>
          <div class="t3">
            <div class="t2">Step 02：</div>
            <p>在有效期内登录DAKA官网「十周年专区」</p>
          </div>
          <div class="t3">
            <div class="t2">Step 03（权益卡兑换特殊流程）：</div>
            <p>输入兑换码及个人信息(姓名、手机号、邮箱、收货地址)</p>
            <p>提交前需单独勾选确认《个人信息处理告知及授权书》，其中将明确告知信息收集目的、留存期限，以及若涉及机票、酒店、俱乐部门票预订需要，是否会向境外接收方（如境外航司、酒店、俱乐部）提供相关个人信息。涉及跨境提供信息的，也将另行取得个人的单独同意。</p>
          </div>
          <div class="t3">
            <div class="t2">Step 04：</div>
            <p>DAKA官方将在3个工作日内完成信息审核，并通过短信/邮件发送确认通知</p>
          </div>
          <div class="t3">
            <div class="t2">Step 05：</div>
            <p>添加相关对接人联系方式，规划行程安排</p>
          </div>
        </li>
        <li>
          <div class="t1">重要说明与免责条款</div>
          <div class="t3">
            <div class="t2">1. 时效说明</div>
            <p>兑换码须于2027年07月31日前完成登记兑换，逾期未兑换视为自动放弃，不予补发</p>
            <p>兑换码兑换完成后，实行强绑定机制。仅限本人使用，不可转赠、不可出售</p>
            <p>权益兑换卡A和权益兑换卡B为欧洲球队参观以及观赛权益，将统一安排于2027年9月左右出发，具体行程时间以官方通知为准。</p>
          </div>
          <div class="t3">
            <div class="t2">2. 行程说明</div>
            <p>奖品兑换后，需提前至少30个工作日与DAKA官方确认行程，包括机票时间、门票场次、住宿地点等，并完成相应出票。</p>
            <p>具体比赛场次的可用性以俱乐部赛程及门票实际供应情况为准。相关行程仅包含机票、门票、住宿，不含签证费用、餐饮、当地交通、保险及其他个人消费。</p>
          </div>
          <div class="t3">
            <div class="t2">3. 合规说明</div>
            <p>获奖者需自行办理赴欧洲的签证，DAKA不予代办。因签证问题导致无法出行，DAKA不承担因此产生的额外范围，但会在合理范围内调整出行时间或给予其他替代性方案。</p>
            <p>获奖者原则上需年满18周岁，具有完全民事行为能力。未满18周岁者获奖的，其兑奖行为应由其法定监护人代理，或经其法定监护人实现书面同意。兑换十周年原箱、原盒的，需由法定监护人代收；兑换出行权益的，法定监护人需全程陪同出行，产生的额外费用自理，并于Step 03同步提供法定监护人签字同意书、可证明监护关系的有效身份证明文件及联系方式。DAKA有权要求中奖者出示能够证明其年龄的有效身份证件，对难以判明是否成年的兑奖者，DAKA有权拒绝兑付直至相关身份信息得到核实。</p>
            <p>本活动奖品不可兑换等额现金，不可转卖。一经发现任何转让、出售行为，DAKA有权取消获奖资格。</p>
          </div>
          <div class="t3">
            <div class="t2">4. 召回及取消条款</div>
            <p>若因不可抗力因素（如战争、自然灾害、突发公共卫生事件、俱乐部赛事取消/延期等）导致奖品无法正常兑现，DAKA有权以等值DAKA商城代金券作为替代方案</p>
            <p>获奖者在完成机票、门票等票务出票后、后因个人原因取消行程，视为自动放弃奖品，不予补发</p>
          </div>
          <div class="t3">
            <div class="t2">5. 最终解释权</div>
            <p>本活动最终解释权在法律允许的范围内归DAKA达咖文化所有</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityRules',
  props: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style scoped>
@import "../../static/css/information.css";
@import "../../static/css/market.css";

.productTable {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}
.informationBox {
  margin-top: 40px;
}
.informationTitle {
  margin-top: 90px;
}
.productTable th,
.productTable td {
  border: 1px solid #e5e5e5;
  padding: 8px 12px;
  text-align: left;
  line-height: 1.5;
}
.productTable th {
  background: #f7f7f7;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/activityRules.vue